const contact = {
  support: "support@withgrayce.com"
};

export default contact;
